import { memo } from "react";
import { connect } from "react-redux";
import { getLoggedUser } from "../../store/selectors/auth";
import ProtectedRoute from ".";

const mapStateToProps = (state) => ({
  isAuthenticated: getLoggedUser(state).isAuthenticated,
});

export default memo(connect(mapStateToProps)(ProtectedRoute));
